/**
 * Line edits behind the findings box's remove buttons and its undo.
 *
 * The findings are one string, one statement per line (see ../ecgStatements).
 * A removal takes one line out; an undo puts that same line back where it was,
 * so anything typed since the removal survives the undo.
 */

/**
 * Take one line, and the line break that belonged to it, out of the text.
 *
 * @param value the whole field
 * @param index the line's position in `value.split("\n")`
 */
export function removeLine(value: string, index: number): string {
    const lines = value.split("\n");

    if (index < 0 || index >= lines.length) {
        return value
    }

    lines.splice(index, 1);

    return lines.join("\n")
}

/**
 * Put a line back at a position — the inverse of {@link removeLine}. A
 * position past the end, after later removals, lands at the end.
 *
 * @param value the whole field
 * @param index where the line was
 * @param text the line
 */
export function insertLine(value: string, index: number, text: string): string {
    if (value === "") {
        return text
    }

    const lines = value.split("\n");

    lines.splice(Math.max(0, Math.min(index, lines.length)), 0, text);

    return lines.join("\n")
}
